import { render, staticRenderFns } from "./TheAddItemFromRecurrentsView.vue?vue&type=template&id=630c9fe5"
import script from "./TheAddItemFromRecurrentsView.vue?vue&type=script&lang=js"
export * from "./TheAddItemFromRecurrentsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports